const envRegex = /cargo\.iparking/g;
const baseUrl = envRegex.test(window.location.hostname) ? 'https://apis.iparking.co.kr' : 'https://apis.iparking.co.kr';

export default `${baseUrl}/garage/api`;
